import { IconReceiptBill } from "@central-icons-react/round-filled-radius-2-stroke-2/IconReceiptBill";
import { IconChevronTopMedium } from "@central-icons-react/round-filled-radius-2-stroke-2/IconChevronTopMedium";
import { IconCrossMedium } from "@central-icons-react/round-filled-radius-2-stroke-2/IconCrossMedium";
import { Dialog } from "@base-ui/react/dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOrderStore } from "../stores/orderStore";
import { useSessionStore } from "../stores/sessionStore";
import { formatPrice } from "../utils/format";
import { trackViewCart } from "../utils/gtm";
import OrderSummary from "./OrderSummary";

export function MobileOrderSummaryBar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { session } = useSessionStore();
  const orderStore = useOrderStore();

  const total = session?.totalAfterDiscount ?? null;
  const hasContent = !!orderStore.selectedDate || !!session;

  if (!hasContent) return null;

  return (
    <>
      <div className="h-20 sm:hidden" />
      <button
        type="button"
        onClick={() => {
          if (session) trackViewCart(session);
          setOpen(true);
        }}
        className="fixed bottom-0 left-0 right-0 z-40 sm:hidden bg-white border-t border-border shadow-[0_-4px_10px_0_rgba(0,0,0,0.05)] flex items-center gap-3 px-5 py-4"
      >
        <div className="bg-blue rounded-full size-12 flex items-center justify-center shrink-0 text-white">
          <IconReceiptBill />
        </div>
        <div className="flex-1 text-left">
          <p className="text-xs text-black/40 leading-none mb-0.5">
            {t("orderSummary.viewBooking")}
          </p>
          {total !== null ? (
            <p className="font-semibold text-lg leading-tight">
              {formatPrice(total)}
            </p>
          ) : (
            <p className="font-semibold text-lg leading-tight text-black/40">
              —
            </p>
          )}
        </div>
        <IconChevronTopMedium className="text-blue size-8 shrink-0" />
      </button>

      <Dialog.Root open={open} onOpenChange={setOpen}>
        <Dialog.Portal>
          <Dialog.Backdrop className="fixed inset-0 bg-black/40 z-50 transition-opacity data-starting-style:opacity-0 data-ending-style:opacity-0" />
          <Dialog.Popup className="fixed bottom-0 left-0 right-0 z-50 bg-background rounded-t-2xl p-5 shadow-xl outline-none transition-[transform,opacity] data-starting-style:translate-y-4 data-starting-style:opacity-0 data-ending-style:translate-y-4 data-ending-style:opacity-0">
            <div className="flex items-center justify-between mb-4">
              <Dialog.Title className="font-semibold text-lg">
                {t("orderSummary.title")}
              </Dialog.Title>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="text-black/40 hover:text-black transition-colors p-1"
              >
                <IconCrossMedium />
              </button>
            </div>
            <OrderSummary hideTitle trackView={false} />
          </Dialog.Popup>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}
